export const transformTSIntoNaturalDate = (timespan: number): string => {
    const datePart = new Date(timespan).toLocaleDateString()
    const timePart = new Date(timespan).toLocaleTimeString()

    return `${datePart} ${timePart}`
}
